import { useRebookSummaryHeader } from "@b2bportal/core-flights-rebook";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./RebookSummaryHeader.module.scss";
import { MissedConnectionDisclaimer } from "@/components/Slots";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import type { RebookSummaryHeaderProps } from "~core-flights-rebook/features/rebook/components/RebookSummaryHeader/types";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookSummaryHeader;

export const RebookSummaryHeader = (props: RebookSummaryHeaderProps) => {
  const { className, children } = props;
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { text } = useRebookSummaryHeader(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>
        <Trans
          i18nKey={"core-flights.rebook.summary.title"}
          values={{
            destinationName: text.destinationName,
            destinationCode: text.destinationCode,
          }}
          components={{
            bold: <span className={cn("bold")} />,
          }}
        />
      </div>
      <div className={cn("subtitle")}>
        <MissedConnectionDisclaimer
          className={`full-screen ${cn("missed-connection-disclaimer")}`}
        />
      </div>
      {children}
    </div>
  );
};
